/* EveryNight storefront interactions (no dependencies). */
(() => {
  'use strict';
  const d = document;
  const w = window;
  const $ = (s, r = d) => r.querySelector(s);
  const $$ = (s, r = d) => Array.from(r.querySelectorAll(s));
  const reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hasIO = 'IntersectionObserver' in w;
  const once = (el, key) => { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; };

  /* ---------- Reveal on scroll ---------- */
  function initReveal(root = d) {
    const els = $$('.en-reveal:not(.is-in)', root);
    if (!hasIO || reduce) { els.forEach((e) => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '60px 0px 60px 0px', threshold: 0 });
    els.forEach((e) => io.observe(e));
    // Safety net: never leave content hidden
    w.setTimeout(() => els.forEach((e) => { if (e.getBoundingClientRect().top < w.innerHeight) e.classList.add('is-in'); }), 1200);
  }

  /* ---------- Header: scrolled state + drawer menu ---------- */
  function initHeader() {
    const h = $('[data-en-header]');
    if (!h || !once(h, 'enInit')) return;
    const onScroll = () => h.classList.toggle('is-scrolled', w.scrollY > 8);
    onScroll();
    w.addEventListener('scroll', onScroll, { passive: true });
    const menu = $('[data-en-menu]');
    const btn = $('[data-en-menu-open]');
    if (!menu || !btn) return;
    const open = () => {
      menu.hidden = false;
      requestAnimationFrame(() => requestAnimationFrame(() => menu.classList.add('is-open')));
      btn.setAttribute('aria-expanded', 'true');
      d.documentElement.classList.add('en-lock');
      const f = $('button[data-en-menu-close]', menu);
      if (f) f.focus();
    };
    const close = () => {
      menu.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      d.documentElement.classList.remove('en-lock');
      setTimeout(() => { menu.hidden = true; }, 380);
      btn.focus();
    };
    btn.addEventListener('click', open);
    $$('[data-en-menu-close]', menu).forEach((b) => b.addEventListener('click', close));
    $$('a', menu).forEach((a) => a.addEventListener('click', () => { const href = a.getAttribute('href') || ''; if (href.includes('#')) close(); }));
    menu.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  /* ---------- Announcement rotation (phones) ---------- */
  function initAnnounce() {
    $$('[data-en-announce]').forEach((t) => {
      const items = $$('.en-announce__item', t);
      if (!items.length || !once(t, 'enInit')) return;
      items[0].classList.add('is-active');
      if (items.length < 2 || reduce) return;
      let i = 0;
      setInterval(() => { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, 3800);
    });
  }

  /* ---------- Horizontal rails (mobile) get dots ---------- */
  function initRails(root = d) {
    $$('[data-en-rail]', root).forEach((rail) => {
      if (!once(rail, 'enDots')) return;
      const items = Array.from(rail.children);
      if (items.length < 2) return;
      const dots = d.createElement('div');
      dots.className = 'en-dots';
      items.forEach((_, i) => {
        const b = d.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to step ' + (i + 1));
        if (i === 0) b.classList.add('is-active');
        b.addEventListener('click', () => rail.scrollTo({ left: items[i].offsetLeft - rail.offsetLeft - (rail.clientWidth - items[i].clientWidth) / 2, behavior: reduce ? 'auto' : 'smooth' }));
        dots.appendChild(b);
      });
      rail.after(dots);
      if (hasIO) {
        const io = new IntersectionObserver((es) => es.forEach((e) => {
          if (e.isIntersecting) { const k = items.indexOf(e.target); Array.from(dots.children).forEach((b, j) => b.classList.toggle('is-active', j === k)); }
        }), { root: rail, threshold: 0.6 });
        items.forEach((it) => io.observe(it));
      }
    });
  }

  /* ---------- Count-up numbers ---------- */
  function initCounters(root = d) {
    const els = $$('[data-en-counter]', root).filter((el) => once(el, 'enInit'));
    if (!els.length || !hasIO || reduce) return;
    const run = (el) => {
      const num = parseFloat(String(el.dataset.enCounter).replace(/,/g, ''));
      if (!isFinite(num)) return;
      const start = performance.now();
      const step = (now) => {
        const k = Math.min(1, (now - start) / 1400);
        el.textContent = Math.round(num * (1 - Math.pow(1 - k, 3))).toLocaleString('en-US');
        if (k < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { io.unobserve(e.target); run(e.target); } }), { threshold: 0.6 });
    els.forEach((el) => { if (el.getBoundingClientRect().top > w.innerHeight * 0.9) { el.textContent = '0'; io.observe(el); } });
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    const track = $('[data-en-track]', root);
    if (!track || !once(root, 'enInit')) return;
    const slides = Array.from(track.children);
    const box = root.parentElement;
    const dots = $$('[data-en-dot]', box);
    const thumbs = $$('[data-en-thumb]', box);
    const count = $('[data-en-index]', root);
    const prev = $('[data-en-prev]', root);
    const next = $('[data-en-next]', root);
    let idx = 0;
    const go = (i) => { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); };
    const mark = (i) => {
      idx = i;
      dots.forEach((dt, k) => dt.classList.toggle('is-active', k === i));
      thumbs.forEach((th, k) => th.classList.toggle('is-active', k === i));
      if (count) count.textContent = String(i + 1);
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    };
    let t;
    track.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))), 60); }, { passive: true });
    dots.forEach((dt) => dt.addEventListener('click', () => go(+dt.dataset.enDot)));
    thumbs.forEach((th) => th.addEventListener('click', () => go(+th.dataset.enThumb)));
    if (prev) prev.addEventListener('click', () => go(idx - 1));
    if (next) next.addEventListener('click', () => go(idx + 1));
    track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); } });
    mark(0);
  }

  /* ---------- Product: pack picker, AJAX add to cart, sticky bar ---------- */
  function initPdp(root) {
    const form = $('[data-en-form]', root);
    if (!form || !once(root, 'enInit')) return;
    const idInput = $('[data-en-id]', form);
    const packs = $$('input[name="en-pack"]', form);
    const atc = $('[data-en-atc]', form);
    const atcPrice = $('[data-en-atc-price]', form);
    const err = $('[data-en-error]', form);
    const sticky = $('[data-en-sticky]', root);
    const stickyPrice = sticky && $('[data-en-sticky-price]', sticky);
    const stickyLabel = sticky && $('[data-en-sticky-label]', sticky);

    const render = () => {
      const sel = packs.find((p) => p.checked);
      if (!sel) return;
      idInput.value = sel.value;
      packs.forEach((p) => p.closest('.en-pack').classList.toggle('is-checked', p === sel));
      if (atcPrice) atcPrice.textContent = sel.dataset.priceText || '';
      if (stickyPrice) stickyPrice.textContent = sel.dataset.priceText || '';
      if (stickyLabel) stickyLabel.textContent = sel.dataset.label || '';
    };
    packs.forEach((p) => p.addEventListener('change', render));
    // Homepage offer cards link here with ?pack=1|2|3
    const want = new URLSearchParams(w.location.search).get('pack');
    if (want) { const m = packs.find((p) => p.dataset.pack === want && !p.disabled); if (m) m.checked = true; }
    render();
    // Offer cards on the sales page pick the pack in place: <a href="#en-buy" data-en-pick="2">
    d.addEventListener('click', (e) => {
      const a = e.target.closest('[data-en-pick]');
      if (!a) return;
      const m = packs.find((p) => p.dataset.pack === a.dataset.enPick && !p.disabled);
      if (m) { m.checked = true; render(); }
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!atc || atc.disabled || atc.classList.contains('is-loading')) return;
      if (err) err.hidden = true;
      atc.classList.add('is-loading');
      const item = { id: Number(idInput.value), quantity: 1 };
      const drawer = d.querySelector('cart-drawer');
      const body = { items: [item] };
      if (drawer && drawer.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map((s) => s.id).join(',');
        body.sections_url = w.location.pathname;
      }
      try {
        const res = await fetch(((w.routes && w.routes.cart_add_url) || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body),
        });
        const data = await res.json();
        if (!res.ok || data.status) {
          if (err) { err.textContent = data.description || data.message || 'Something went wrong. Please try again.'; err.hidden = false; }
          return;
        }
        if (typeof w.publish === 'function' && w.PUB_SUB_EVENTS) { try { w.publish(w.PUB_SUB_EVENTS.cartUpdate, { source: 'en-product', productVariantId: item.id, cartData: data }); } catch (x) { /* noop */ } }
        if (drawer && data.sections) { drawer.classList.remove('is-empty'); drawer.renderContents({ id: item.id, sections: data.sections }); }
        else { w.location.href = (w.routes && w.routes.cart_url) || '/cart'; }
      } catch (x) {
        form.submit();
      } finally {
        atc.classList.remove('is-loading');
      }
    });

    // Sticky bar shows once the real button has scrolled away
    if (sticky && atc && hasIO) {
      const btn = $('[data-en-sticky-btn]', sticky);
      const io = new IntersectionObserver((es) => es.forEach((en) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        if (btn) btn.tabIndex = show ? 0 : -1;
        d.documentElement.classList.toggle('en-has-sticky', show);
      }));
      io.observe(atc);
      if (btn) btn.addEventListener('click', () => { if (form.requestSubmit) form.requestSubmit(); else atc.click(); });
    }
  }

  /* ---------- In-page anchors (offset for the sticky header) ---------- */
  function initAnchors() {
    d.addEventListener('click', (e) => {
      const a = e.target.closest('a[href*="#"]');
      if (!a) return;
      const url = new URL(a.href, w.location.href);
      if (url.pathname !== w.location.pathname || !url.hash) return;
      const el = d.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (!el) return;
      e.preventDefault();
      const header = $('.en-header');
      const off = (header ? header.getBoundingClientRect().height : 64) + 10;
      w.scrollTo({ top: el.getBoundingClientRect().top + w.scrollY - off, behavior: reduce ? 'auto' : 'smooth' });
      history.replaceState(null, '', url.hash);
    });
  }

  /* ---------- Cart drawer: swap the 1-pack for the 2-pack in one tap ---------- */
  function initSwap() {
    d.addEventListener('click', async (e) => {
      const b = e.target.closest('[data-en-swap]');
      if (!b || b.classList.contains('is-loading')) return;
      e.preventDefault();
      b.classList.add('is-loading');
      const drawer = d.querySelector('cart-drawer');
      const json = { 'Content-Type': 'application/json', Accept: 'application/json' };
      const r = w.routes || {};
      try {
        await fetch((r.cart_change_url || '/cart/change') + '.js', { method: 'POST', headers: json, body: JSON.stringify({ line: Number(b.dataset.line), quantity: 0 }) });
        const body = { items: [{ id: Number(b.dataset.add), quantity: 1 }] };
        if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map((s) => s.id).join(','); body.sections_url = w.location.pathname; }
        const res = await fetch((r.cart_add_url || '/cart/add') + '.js', { method: 'POST', headers: json, body: JSON.stringify(body) });
        const data = await res.json();
        if (res.ok && drawer && data.sections) drawer.renderContents({ id: Number(b.dataset.add), sections: data.sections });
        else w.location.href = r.cart_url || '/cart';
      } catch (x) {
        w.location.href = b.getAttribute('href');
      }
    });
  }

  function initAll(root = d) {
    initReveal(root);
    initRails(root);
    initCounters(root);
    $$('[data-en-gallery]', root).forEach(initGallery);
    $$('[data-en-pdp]', root).forEach(initPdp);
  }
  function boot() { initHeader(); initAnnounce(); initAnchors(); initSwap(); initAll(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  d.addEventListener('shopify:section:load', (e) => { if (e.target.querySelector('[data-en-header]')) initHeader(); if (e.target.querySelector('[data-en-announce]')) initAnnounce(); initAll(e.target); });
})();
